import { useState } from "react";
import { Drawer, Menu } from "antd";
import { SHEET_CLASS_NAMES, SHEET_MENU_STYLE, SHEET_STYLES } from "./constants";
import MenuTrigger from "./MenuTrigger";
import { initialOpenKeys } from "./utils";

/**
 * A breadcrumb menu as a bottom sheet — the phone treatment. Same items as the
 * dropdown, but sections expand in place: a dropdown's submenus open sideways, and
 * on a phone there is no room for them beside the menu (in Arabic they were pushed
 * off the left edge). The sheet is modal and locks the page, so unlike the dropdown
 * it has nothing scrolling underneath to close on.
 */
export default function BreadcrumbSheet({
  items,
  selectedKeys,
  ariaLabel,
  title,
  className,
  children,
}) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <MenuTrigger
        ariaLabel={ariaLabel}
        popupRole="dialog"
        open={open}
        className={className}
        onClick={() => setOpen(true)}
      >
        {children}
      </MenuTrigger>
      <Drawer
        open={open}
        onClose={close}
        placement="bottom"
        height="auto"
        title={title}
        classNames={SHEET_CLASS_NAMES}
        styles={SHEET_STYLES}
      >
        <Menu
          mode="inline"
          items={items}
          selectedKeys={selectedKeys}
          defaultOpenKeys={initialOpenKeys(items, selectedKeys)}
          onClick={close}
          style={SHEET_MENU_STYLE}
        />
      </Drawer>
    </>
  );
}
